import '@styles/app.css'
import { initSite } from '@layout/site'
import { mount } from '@shared'
import { ContactForm, HomeFaq } from '@features/Home'

initSite()
mount('faq-root', <HomeFaq />)
mount('contact-form-root', <ContactForm />)
